var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "65.2 173.5 180 180",
    style: {
      enableBackground: "new 65.2 173.5 180 180"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#0080ff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_229_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_690_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_691_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st0",
    d: "M155.2 351.7v-34.2c36.2 0 64.3-35.9 50.4-74-5.1-14.1-16.4-25.4-30.5-30.5-38.1-13.8-74 14.2-74 50.4H67c0-57.7 55.8-102.7 116.3-83.8 26.4 8.3 47.5 29.3 55.7 55.7 18.9 60.6-26 116.4-83.8 116.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st0",
    d: "M155.3 317.6h-34v-34h34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st0",
    d: "M121.3 343.8H95.1v-26.2h26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st0",
    d: "M95.1 317.6H73.2v-21.9h21.9v21.9z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjAiIHk9IjAiIHZpZXdCb3g9IjY1LjIgMTczLjUgMTgwIDE4MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyA2NS4yIDE3My41IDE4MCAxODAiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZT4uc3Qwe2ZpbGw6IzAwODBmZn08L3N0eWxlPjxnIGlkPSJYTUxJRF8yMjlfIj48ZyBpZD0iWE1MSURfNjkwXyI+PGcgaWQ9IlhNTElEXzY5MV8iPjxnIGlkPSJYTUxJRF80NF8iPjxnIGlkPSJYTUxJRF80OF8iPjxwYXRoIGlkPSJYTUxJRF80OV8iIGNsYXNzPSJzdDAiIGQ9Ik0xNTUuMiAzNTEuN3YtMzQuMmMzNi4yIDAgNjQuMy0zNS45IDUwLjQtNzQtNS4xLTE0LjEtMTYuNC0yNS40LTMwLjUtMzAuNS0zOC4xLTEzLjgtNzQgMTQuMi03NCA1MC40SDY3YzAtNTcuNyA1NS44LTEwMi43IDExNi4zLTgzLjggMjYuNCA4LjMgNDcuNSAyOS4zIDU1LjcgNTUuNyAxOC45IDYwLjYtMjYgMTE2LjQtODMuOCAxMTYuNHoiLz48L2c+PHBhdGggaWQ9IlhNTElEXzQ3XyIgY2xhc3M9InN0MCIgZD0iTTE1NS4zIDMxNy42aC0zNHYtMzRoMzR6Ii8+PHBhdGggaWQ9IlhNTElEXzQ2XyIgY2xhc3M9InN0MCIgZD0iTTEyMS4zIDM0My44SDk1LjF2LTI2LjJoMjYuMnoiLz48cGF0aCBpZD0iWE1MSURfNDVfIiBjbGFzcz0ic3QwIiBkPSJNOTUuMSAzMTcuNkg3My4ydi0yMS45aDIxLjl2MjEuOXoiLz48L2c+PC9nPjwvZz48L2c+PC9zdmc+Cg==";